import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormLabel from '../../../../library/form/components/FormLabel';

import DocTagSelector from '../../../cmn/DocTagSelector'

const AlarmOwner = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)

    return (
        <div className="uiRow">
            <div className="uiSpacer15">
                <span className="uiLbl uiInline">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sRRFrequency" }} value="Alarm Owner" />
                </span>
                <div className="uiInline">
                    <DocTagSelector formObject={formObject} viewData={viewData} />
                    {//<uc1:vCMNTagSelector ID="vCMNAlarmOwner" HideShortHand="true"  /> <DocTagSelector></DocTagSelector>
                    }
                </div>
            </div>
        </div>
    )
}

export default withView(AlarmOwner, "alarmOwner", "alarmOwner")